import i18n from '../../../i18n'
import { evidenceDiaryDetailSearchFieldTypes } from './fieldTypes'
import { evidenceDiaryDetailSearchFields } from './fields'

export const evidenceDiaryDetailSearchInputs = () => {
    const inputs = evidenceDiaryDetailSearchFieldTypes()
    
    return {
        mainForm: [
            {
                type: 'array',
                name: 'idGroup',
                children: inputs[evidenceDiaryDetailSearchFields.INTERNAL_APP_PROPERTY_ID],
            },
            {
                type: 'array',
                name: 'personGroup',
                children: inputs[evidenceDiaryDetailSearchFields.FULL_NAME_SELLER],
            },
            {
                type: 'array',
                name: 'locationStreetGroup',
                children: [
                    inputs[evidenceDiaryDetailSearchFields.LOCATION],
                    inputs[evidenceDiaryDetailSearchFields.STREET],
                ],
            },
            {
                type: 'array',
                name: 'priceGroup',
                children: [
                    {
                        type: 'grouped',
                        name: 'evidenceDiaryPriceGrouped',
                        label: i18n.t('table.header.diary.price', { price: '€' }),
                        colProps: { sm: 12 },
                        items: [
                            inputs[evidenceDiaryDetailSearchFields.PRICE_FROM],
                            inputs[evidenceDiaryDetailSearchFields.PRICE_TO],
                        ],
                    },
                ],
            },
            {
                type: 'array',
                name: 'dateGroup',
                children: [
                    {
                        type: 'grouped',
                        name: 'evidenceDiaryDateGrouped',
                        label: i18n.t('app.common.contractDate'),
                        colProps: { sm: 12 },
                        items: [
                            inputs[evidenceDiaryDetailSearchFields.CREATED_FROM],
                            inputs[evidenceDiaryDetailSearchFields.CREATED_TO],
                        ],
                    },
                ],
            },
        ],
    }
}
